'use strict';

$(document).ready(function () {
    $('[data-is-session-login-pdp]').data('is-session-login-pdp') ? $('.tab-subscription-pdp').trigger('click') : null;
})